import { DetailsLayout } from "@features/layout";

export const CardPage = () => {
  return <DetailsLayout />;
};
